export function getAgreementPdfUrl(relationshipId, pdfHost) {
  return "".concat(pdfHost, "/relationship-pdf/").concat(relationshipId);
}
export function relationshipDisplayedTitle(relationshipTitle, opposingPartyName) {
  return relationshipTitle !== opposingPartyName ? relationshipTitle : null;
}